<h1 class="title">Building Property Sets</h1>
<h5>Manage imported and user-defined property sets</h5>
<div class="cas-wrapper">
    <acabim-bim-visualiser-location-selector
        [basicLocation]="false"
        [showBimViewer]="false"
        (locationEmitter)="selectLocation($event)"
        [cardTitle]="'Location & Building'"
        [collapsed]="true"
    >
    </acabim-bim-visualiser-location-selector>

    <acabim-card [cardContent]="properties"
                 [isCollapsible]="true" [isCollapsed]="false"
                 cardHeading="Property Sets"
                 [hasHelpButton]="true"
                 [helpMessage]="'Edit existing properties or click on each entity and add user-specified properties, if desired.'">
    </acabim-card>


</div>

<ng-template #properties>
    <div class="cas-pad">
        <acabim-building-details-viewer
                *ngIf="selectedProject"
                [projectId]="selectedProject?.id"
                [storeyGuid]="selectedStorey?.guid"
                [spaceGuid]="selectedSpace?.guid"
                [hadDetailedView]="true"
                [showDetailView]="showDetailView"
                [editable]=true></acabim-building-details-viewer>
    </div>
</ng-template>
